import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ComponentPageHeader from '../../../Common/PageHeader/ComponentPageHeader';
import styles from '../utils/AnalystReportsStyle.module.scss';
import bannerImage from '../../../assets/BannerImage.svg';
import { getDesktopVersion } from '../../ComponentNavBar/redux/dashboardSlice';
import { RootState } from '../../../redux/rootState';
import { setLoader } from '../../../redux/loaderSlice';

function ReportsDashBoard() {
  const dispatch = useDispatch();
  const { version, isVersionLoading } = useSelector((state: RootState) => state.dashboardReducer);
  useEffect(() => {
    dispatch(getDesktopVersion());
  }, []);

  useEffect(() => {
    dispatch(setLoader(isVersionLoading));
  }, [isVersionLoading]);

  return (
    <>
      <ComponentPageHeader
        subHeading="Dashboard"
        version={version}
        versionLabel="Current Desktop Version"
      />
      <div className={`${styles.dashboardCardWrapper} div_job_container_info`}>
        <div className="dashboardBanner"><img src={bannerImage} alt="Banner" height={200} /></div>
      </div>
      <div className="footer">
        Copyright © 2023 &nbsp;
        <Link to="http://taiservices.com/" target="_blank">Taiservices</Link>
        . Designed by&nbsp;
        <Link to="https://binmile.com/" target="_blank">Binmile Technologies Private Limited</Link>
        .&nbsp;All rights reserved.
      </div>
    </>
  );
}

export default ReportsDashBoard;
